import clsx from 'clsx'
import { useState, type ReactNode } from 'react'
import { View } from 'react-native'

import { ActionSheet } from '@/src/elements/action'
import { Button } from '@/src/elements/button/default'
import { Card } from '@/src/elements/card'
import type { TListboxItemProps } from '@/src/elements/listbox'
import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useOnChange } from '@/src/general/hooks/useOnChange'

type TCollapsableNoteProps = {
  text: string
  options: TListboxItemProps[]
  className?: string
  isThanked: boolean
}
export const CollapsableNote = ({ isThanked, text, options, className }: TCollapsableNoteProps): ReactNode => {
  const [isCollapsed, setIsCollapsed] = useState(isThanked)

  useOnChange(isThanked, () => {
    if (isThanked) setIsCollapsed(true)
  })

  return (
    <Card
      shadow="sm"
      isPressable
      onPress={() => setIsCollapsed(!isCollapsed)}
      className={clsx('flex-row p-1', className, { 'bg-default-bg-loading/50': isCollapsed })}
    >
      <Typography
        className={clsx('py-2 pl-3', { 'overflow-hidden text-ellipsis whitespace-nowrap text-xs': isCollapsed })}
        numberOfLines={isCollapsed ? 1 : undefined}
      >
        {text}
      </Typography>
      <View className={clsx('flex-col items-center', isCollapsed ? 'justify-center' : 'justify-between')}>
        {!isCollapsed && (
          <ActionSheet items={options}>
            <Button
              size="xs"
              isIconOnly
              startIcon={ICON.ELLIPSIS_VERTICAL}
              colors="default"
              variant="light"
              contrast="default"
              testID={TEST_ID.INTENTION.UPLIFT.OPTIONS.BUTTON}
            />
          </ActionSheet>
        )}
        <View className="flex-row items-center justify-center p-1.5">
          <Icon
            size="sm"
            testID={TEST_ID.INTENTION.UPLIFT.TOGGLE}
            name={isCollapsed ? ICON.CHEVRON_COLLAPSABLE_CLOSE : ICON.CHEVRON_COLLAPSABLE_OPEN}
          />
        </View>
      </View>
    </Card>
  )
}
